import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL || 'http://localhost:5000';

// Thunk to delete the business account
export const deleteBusinessAccount = createAsyncThunk(
  "user/deleteAccount",
  async (userId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) throw new Error("No authentication token found.");
      if (!userId) throw new Error("User ID is missing.");

      const response = await axios.delete(
        `${baseUrl}/business/hard-delete/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || "Failed to delete account."
      );
    }
  }
);

const userSlice = createSlice({
  name: "user",
  initialState: {
    user: null,
    status: "idle",
    error: null,
    deletionComplete: false,
  },
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
    },
    clearUser(state) {
      state.user = null;
      state.status = "idle";
      state.error = null;
      state.deletionComplete = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteBusinessAccount.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.deletionComplete = false;
      })
      .addCase(deleteBusinessAccount.fulfilled, (state) => {
        state.status = "succeeded";
        state.user = null;
        state.deletionComplete = true;
        localStorage.clear(); // clear localStorage on success
      })
      .addCase(deleteBusinessAccount.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Account deletion failed.";
        state.deletionComplete = false;
      });
  },
});

export const { setUser, clearUser } = userSlice.actions;

export default userSlice.reducer;
